//@flow
import CreateAccountModalClass from './createAccountModalClass';

export default new CreateAccountModalClass();
